export default "__VITE_ASSET__CPoYwy8o__"